"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importDefault(require("styled-components"));
var weakPasswordLine = require('../../assets/img/password-strength-zwak.svg');
var strongPasswordLine = require('../../assets/img/password-strength-sterk.svg');
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 55px;\n  left: 0;\n  right: 0;\n"], ["\n  position: absolute;\n  top: 55px;\n  left: 0;\n  right: 0;\n"])));
var Line = (0, styled_components_1.default)('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 5px;\n  background: url(", ")\n    0 0 ", ";\n"], ["\n  height: 5px;\n  background: url(", ")\n    0 0 ", ";\n"])), function (props) {
    return props.strength === 'strong' ? strongPasswordLine : weakPasswordLine;
}, function (props) { return props.strength === 'weak' && 'no-repeat'; });
var Status = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 5px 10px 0 0;\n  font-family: Montserrat;\n  font-size: 12px;\n  color: #9a9183;\n  text-align: right;\n"], ["\n  padding: 5px 10px 0 0;\n  font-family: Montserrat;\n  font-size: 12px;\n  color: #9a9183;\n  text-align: right;\n"])));
var PasswordStrength = function (_a) {
    var strength = _a.strength, _b = _a.strongPasswordMsg, strongPasswordMsg = _b === void 0 ? '' : _b, _c = _a.weakPasswordMsg, weakPasswordMsg = _c === void 0 ? '' : _c;
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(Line, { strength: strength }),
        strength === 'strong' && strongPasswordMsg
            ? (react_1.default.createElement(Status, null, strongPasswordMsg))
            : strength === 'weak' && weakPasswordMsg
                ? (react_1.default.createElement(Status, null, weakPasswordMsg))
                : null));
};
PasswordStrength.propTypes = {
    strength: prop_types_1.default.string.isRequired,
    strongPasswordMsg: prop_types_1.default.string,
    weakPasswordMsg: prop_types_1.default.string
};
exports.default = PasswordStrength;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=PasswordStrength.js.map